import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageCapacitySection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsAvailabilityCapacity, {
      state: { optionData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Capacity</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="text-sm font-bold">Min # of participants</p>
              <p className="text-secondary capitalize">
                {optionData?.minParticipants ?? "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Max # of participants</p>
              <p className="text-secondary capitalize">
                {optionData?.maxParticipants ?? "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="text-sm font-bold">
                Do your exceptions share the same capacity?
              </p>
              <p className="text-secondary capitalize">
                {optionData?.expectedParticipants ? "No" : "Yes"}
              </p>
            </div>
          </div>
          {optionData?.expectedParticipants === true && (
            <div className="w-full">
              <div className="space-y-2">
                <p className="text-sm font-bold">Expected Max Participants</p>
                <p className="text-secondary capitalize">
                  {optionData?.expectedMaxParticipants ?? "N/A"}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
